var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.25C1.5 3.62665 3.62665 1.5 6.25 1.5C8.87335 1.5 11 3.62665 11 6.25C11 8.87335 8.87335 11 6.25 11C3.62665 11 1.5 8.87335 1.5 6.25ZM6.25 0.5C3.07436 0.5 0.5 3.07436 0.5 6.25C0.5 9.42564 3.07436 12 6.25 12C7.65771 12 8.94726 11.4941 9.9468 10.6543L12.6461 13.3536C12.8414 13.5489 13.158 13.5489 13.3532 13.3536C13.5485 13.1584 13.5485 12.8418 13.3532 12.6465L10.6539 9.9472C11.494 8.94761 12 7.65789 12 6.25C12 3.07436 9.42564 0.5 6.25 0.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.752f7f08.svg";
export { ForwardRef as ReactComponent };